import { createToaster } from '../../infra';

export const { useToast } = createToaster({
    options: {
        variant: 'solid',
        position: 'bottom-right',
        isClosable: true,
    },
});
